function msContributionCartReady() {
  return typeof fetchConfig === 'function' && typeof routes !== 'undefined' && routes.cart_add_url;
}

if (!customElements.get('mariner-contribution-slider')) {
  customElements.define(
    'mariner-contribution-slider',
    class MarinerContributionSlider extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        const dataEl = this.querySelector('[data-ms-contribution-variants]');
        this.range = this.querySelector('[data-ms-contribution-range]');
        this.output = this.querySelector('[data-ms-slider-output]');
        if (!dataEl || !this.range || !this.output) return;

        this.mode = this.dataset.mode || 'product';
        this.tierRoot =
          this.mode === 'tier' && this.dataset.tierRoot
            ? document.getElementById(this.dataset.tierRoot)
            : null;
        this.productInfo = this.mode === 'product' ? this.closest('product-info') : null;

        try {
          this.config = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }

        this.variants = this.config.variants;
        if (!this.variants || this.variants.length === 0) return;

        this._initTierCart();

        if (this.mode === 'product') {
          this.resolveVariantSelects();
        }

        const initial = parseInt(this.range.value, 10);
        this.applyVariantAtIndex(initial, false);

        this.range.addEventListener('input', () => {
          const i = parseInt(this.range.value, 10);
          this.updateOutputAtIndex(i);
          if (this.mode === 'tier') {
            const row = this.variants[i];
            if (!row) return;
            if (row.available) this.renderTierPrice(row);
            this.syncTierCtaState(row);
          }
        });

        this.range.addEventListener('change', () => {
          const i = parseInt(this.range.value, 10);
          this.applyVariantAtIndex(i, true);
        });
      }

      disconnectedCallback() {
        this._variantSelectsObserver?.disconnect();
        this._variantSelectsObserver = null;
      }

      _initTierCart() {
        this.priceWrap = this.tierRoot?.querySelector('[data-ms-tier-price]');
        this.addToCartBtn = this.tierRoot?.querySelector('[data-ms-tier-add-to-cart]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this._addInFlight = false;
        this._selectedIndex = this.config?.selectedIndex ?? 0;

        if (this.addToCartBtn) {
          if (document.querySelector('cart-drawer')) {
            this.addToCartBtn.setAttribute('aria-haspopup', 'dialog');
          }
          this.addToCartBtn.addEventListener('click', (evt) => this.addToCart(evt));
        }
      }

      getSelectedVariant() {
        const index = parseInt(this.range.value, 10);
        return this.variants[index] || null;
      }

      resolveVariantSelects() {
        if (!this.productInfo) return null;
        this.variantSelects = this.productInfo.querySelector('variant-selects');
        if (this.variantSelects || this._variantSelectsObserver) return this.variantSelects;

        this._variantSelectsObserver = new MutationObserver(() => {
          this.variantSelects = this.productInfo?.querySelector('variant-selects');
          if (this.variantSelects) {
            this._variantSelectsObserver.disconnect();
            this._variantSelectsObserver = null;
          }
        });
        this._variantSelectsObserver.observe(this.productInfo, { childList: true, subtree: true });
        return this.variantSelects;
      }

      updateOutputAtIndex(index) {
        const row = this.variants[index];
        if (!row || !this.output) return;
        this.output.textContent = row.priceLabel;
        this.range.setAttribute('aria-valuenow', String(index));
        this.range.setAttribute('aria-valuetext', row.priceLabel);
      }

      applyVariantAtIndex(index, syncProduct) {
        const row = this.variants[index];
        if (!row) return;

        this.updateOutputAtIndex(index);

        if (this.mode === 'tier') {
          this.syncTierCtaState(row);
          if (!row.available) return;
          this.renderTierPrice(row);
          return;
        }

        if (syncProduct) this.selectProductVariant(row);
      }

      syncTierCtaState(row) {
        if (!this.addToCartBtn || this._addInFlight) return;
        if (!row?.available) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.setAttribute('aria-disabled', 'true');
          this.showAddToCartError('This amount is currently unavailable.');
          return;
        }
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.removeAttribute('aria-disabled');
        this.clearAddToCartError();
      }

      renderTierPrice(v) {
        if (!this.priceWrap) return;
        while (this.priceWrap.firstChild) {
          this.priceWrap.removeChild(this.priceWrap.firstChild);
        }
        if (v.compare_gt && v.compare) {
          const strike = document.createElement('span');
          strike.style.textDecoration = 'line-through';
          strike.style.opacity = '0.55';
          strike.style.fontSize = '0.65em';
          strike.style.marginRight = '0.35em';
          strike.textContent = v.compare;
          this.priceWrap.appendChild(strike);
        }
        const main = document.createElement('span');
        main.setAttribute('data-ms-tier-price-main', '');
        main.textContent = v.priceLabel;
        this.priceWrap.appendChild(main);
        this.updateTierCtaLabel(v);
      }

      updateTierCtaLabel(row) {
        if (!this.addToCartBtn || !row?.priceLabel) return;
        const labelEl = this.addToCartBtn.querySelector('[data-ms-tier-cta-label]');
        if (!labelEl) return;
        const template = this.addToCartBtn.getAttribute('data-ms-tier-cta-template');
        if (template && template.includes('{amount}')) {
          labelEl.textContent = template.replace(/\{amount\}/g, row.priceLabel);
        }
      }

      selectProductVariant(row) {
        const vs = this.variantSelects || this.resolveVariantSelects();
        if (!vs) return;
        const ids = row.optionValueIds;
        if (!ids || !ids.length) return;

        ids.forEach((id) => {
          const input = vs.querySelector(`input[type="radio"][data-option-value-id="${id}"]`);
          if (input) input.checked = true;
        });

        ids.forEach((id) => {
          const opt = vs.querySelector(`option[data-option-value-id="${id}"]`);
          if (opt) {
            const sel = opt.closest('select');
            if (sel) sel.value = opt.value;
          }
        });

        const trigger =
          vs.querySelector(`input[type="radio"][data-option-value-id="${ids[0]}"]`) ||
          vs.querySelector('select.select__select');

        if (trigger) trigger.dispatchEvent(new Event('change', { bubbles: true }));
      }

      addToCart(evt) {
        if (this._addInFlight || !this.addToCartBtn) return;

        const row = this.getSelectedVariant();
        if (!row || !row.id) return;
        if (!row.available) {
          this.syncTierCtaState(row);
          return;
        }
        if (this.addToCartBtn.getAttribute('aria-disabled') === 'true') return;

        if (!msContributionCartReady()) {
          console.error('Mariner contribution slider: theme cart scripts not loaded.');
          this.showAddToCartError('Unable to add to cart. Please refresh and try again.');
          return;
        }

        const giftForm =
          typeof msFindFoundersGiftForm === 'function' ? msFindFoundersGiftForm(this.tierRoot) : null;
        const giftCheck = giftForm?.validate?.();
        if (giftCheck && !giftCheck.ok) {
          this.showAddToCartError(giftCheck.message);
          giftForm?.emailInput?.focus?.();
          return;
        }

        this._addInFlight = true;
        this.setAddToCartLoading(true);
        this.clearAddToCartError();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', row.id);
        formData.append('quantity', 1);
        giftForm?.appendToFormData?.(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'mariner-contribution-slider',
                productVariantId: row.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showAddToCartError(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mariner-contribution-slider',
              productVariantId: row.id,
              cartData: response,
            });

            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this._addInFlight = false;
            this.setAddToCartLoading(false);
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (typeof CartPerformance !== 'undefined' && evt) {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      setAddToCartLoading(loading) {
        if (!this.addToCartBtn) return;
        const spinner = this.addToCartBtn.querySelector('.loading__spinner');
        if (loading) {
          this.addToCartBtn.setAttribute('aria-disabled', 'true');
          this.addToCartBtn.classList.add('loading');
          spinner?.classList.remove('hidden');
          return;
        }

        this.addToCartBtn.classList.remove('loading');
        spinner?.classList.add('hidden');
        this.syncTierCtaState(this.getSelectedVariant());
      }

      clearAddToCartError() {
        const wrap = this.tierRoot?.querySelector('[data-ms-tier-cart-error]');
        if (!wrap) return;
        wrap.hidden = true;
        const msg = wrap.querySelector('[data-ms-tier-cart-error-message]');
        if (msg) msg.textContent = '';
      }

      showAddToCartError(message) {
        const wrap = this.tierRoot?.querySelector('[data-ms-tier-cart-error]');
        if (!wrap || !message) return;
        const msg = wrap.querySelector('[data-ms-tier-cart-error-message]');
        if (msg) msg.textContent = message;
        wrap.hidden = false;
      }
    }
  );
}

if (!customElements.get('mariner-contribution-picker')) {
  customElements.define(
    'mariner-contribution-picker',
    class MarinerContributionPicker extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        const dataEl = this.querySelector('[data-ms-contribution-variants]');
        if (!dataEl) return;

        this.tierRoot = this.dataset.tierRoot
          ? document.getElementById(this.dataset.tierRoot)
          : null;

        try {
          this.config = JSON.parse(dataEl.textContent);
        } catch (e) {
          return;
        }

        this.variants = this.config.variants;
        if (!this.variants || this.variants.length === 0) return;

        this.priceWrap = this.tierRoot?.querySelector('[data-ms-tier-price]');
        this.addToCartBtn = this.tierRoot?.querySelector('[data-ms-tier-add-to-cart]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this._addInFlight = false;
        this._selectedIndex = this.config.selectedIndex ?? 0;

        if (this.addToCartBtn) {
          if (document.querySelector('cart-drawer')) {
            this.addToCartBtn.setAttribute('aria-haspopup', 'dialog');
          }
          this.addToCartBtn.addEventListener('click', (evt) => this.addToCart(evt));
        }

        this.querySelectorAll('[data-ms-contribution-pill]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
            this.selectIndex(parseInt(btn.getAttribute('data-variant-index'), 10), true);
          });
        });

        const select = this.querySelector('[data-ms-contribution-select]');
        if (select) {
          select.addEventListener('change', () => {
            const option = select.options[select.selectedIndex];
            if (!option || option.disabled) return;
            this.selectIndex(parseInt(option.getAttribute('data-variant-index'), 10), true);
          });
        }

        this.selectIndex(this._selectedIndex, false);
      }

      getSelectedVariant() {
        return this.variants[this._selectedIndex] || null;
      }

      selectIndex(index, updateUi) {
        const row = this.variants[index];
        if (!row || !row.available) return;

        this._selectedIndex = index;

        if (updateUi) {
          this.querySelectorAll('[data-ms-contribution-pill]').forEach((btn) => {
            const on = parseInt(btn.getAttribute('data-variant-index'), 10) === index;
            btn.classList.toggle('is-selected', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          const select = this.querySelector('[data-ms-contribution-select]');
          if (select) {
            const option = select.querySelector(`option[data-variant-index="${index}"]`);
            if (option) select.value = option.value;
          }
        }

        this.renderTierPrice(row);
        this.syncTierCtaState(row);
      }

      syncTierCtaState(row) {
        if (!this.addToCartBtn || this._addInFlight) return;
        if (!row?.available) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.setAttribute('aria-disabled', 'true');
          this.showAddToCartError('This amount is currently unavailable.');
          return;
        }
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.removeAttribute('aria-disabled');
        this.clearAddToCartError();
      }

      renderTierPrice(v) {
        if (!this.priceWrap) return;
        while (this.priceWrap.firstChild) {
          this.priceWrap.removeChild(this.priceWrap.firstChild);
        }
        if (v.compare_gt && v.compare) {
          const strike = document.createElement('span');
          strike.style.textDecoration = 'line-through';
          strike.style.opacity = '0.55';
          strike.style.fontSize = '0.65em';
          strike.style.marginRight = '0.35em';
          strike.textContent = v.compare;
          this.priceWrap.appendChild(strike);
        }
        const main = document.createElement('span');
        main.setAttribute('data-ms-tier-price-main', '');
        main.textContent = v.priceLabel;
        this.priceWrap.appendChild(main);
        this.updateTierCtaLabel(v);
      }

      updateTierCtaLabel(row) {
        if (!this.addToCartBtn || !row?.priceLabel) return;
        const labelEl = this.addToCartBtn.querySelector('[data-ms-tier-cta-label]');
        if (!labelEl) return;
        const template = this.addToCartBtn.getAttribute('data-ms-tier-cta-template');
        if (template && template.includes('{amount}')) {
          labelEl.textContent = template.replace(/\{amount\}/g, row.priceLabel);
        }
      }

      addToCart(evt) {
        if (this._addInFlight || !this.addToCartBtn) return;

        const row = this.getSelectedVariant();
        if (!row || !row.id) return;
        if (!row.available) {
          this.syncTierCtaState(row);
          return;
        }
        if (this.addToCartBtn.getAttribute('aria-disabled') === 'true') return;

        if (!msContributionCartReady()) {
          console.error('Mariner contribution picker: theme cart scripts not loaded.');
          this.showAddToCartError('Unable to add to cart. Please refresh and try again.');
          return;
        }

        const giftForm =
          typeof msFindFoundersGiftForm === 'function' ? msFindFoundersGiftForm(this.tierRoot) : null;
        const giftCheck = giftForm?.validate?.();
        if (giftCheck && !giftCheck.ok) {
          this.showAddToCartError(giftCheck.message);
          giftForm?.emailInput?.focus?.();
          return;
        }

        this._addInFlight = true;
        this.setAddToCartLoading(true);
        this.clearAddToCartError();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', row.id);
        formData.append('quantity', 1);
        giftForm?.appendToFormData?.(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'mariner-contribution-picker',
                productVariantId: row.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showAddToCartError(response.description);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mariner-contribution-picker',
              productVariantId: row.id,
              cartData: response,
            });

            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this._addInFlight = false;
            this.setAddToCartLoading(false);
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (typeof CartPerformance !== 'undefined' && evt) {
              CartPerformance.measureFromEvent('add:user-action', evt);
            }
          });
      }

      setAddToCartLoading(loading) {
        if (!this.addToCartBtn) return;
        const spinner = this.addToCartBtn.querySelector('.loading__spinner');
        if (loading) {
          this.addToCartBtn.setAttribute('aria-disabled', 'true');
          this.addToCartBtn.classList.add('loading');
          spinner?.classList.remove('hidden');
          return;
        }

        this.addToCartBtn.classList.remove('loading');
        spinner?.classList.add('hidden');
        this.syncTierCtaState(this.getSelectedVariant());
      }

      clearAddToCartError() {
        const wrap = this.tierRoot?.querySelector('[data-ms-tier-cart-error]');
        if (!wrap) return;
        wrap.hidden = true;
        const msg = wrap.querySelector('[data-ms-tier-cart-error-message]');
        if (msg) msg.textContent = '';
      }

      showAddToCartError(message) {
        const wrap = this.tierRoot?.querySelector('[data-ms-tier-cart-error]');
        if (!wrap || !message) return;
        const msg = wrap.querySelector('[data-ms-tier-cart-error-message]');
        if (msg) msg.textContent = message;
        wrap.hidden = false;
      }
    }
  );
}
